export const LEARN_MORE_PRACTICE_SECTION = [
  {
    title: "了解最佳实践背后的客户案例",
    description:
      "TiDB 现已被 3000 多家不同行业的领先企业应用在实际生产环境，探索它们是如何利用 TiDB 来破解业务挑战并走向成功的。",
    link: {
      label: "查看详情",
      value: "/case",
    },
  },
]

export const LEARN_MORE_INSIGHT_SECTION = [
  {
    title: "了解我们的解决方案",
    description:
      "TiDB 面向丰富的业务场景，提供整套行业和技术解决方案，助力客户安全高效开发。",
    link: {
      label: "查看详情",
      value: "/solution",
    },
  },
]

export const ALL_CASE_SECTION = {
  title: "客户案例",
  desc: "TiDB 正在为 3000 多家不同行业的领先企业提供服务",
  more: "展开更多案例",
}
